import { render, staticRenderFns } from "./ButelProxyList.vue?vue&type=template&id=ffc252a0&scoped=true&"
import script from "./ButelProxyList.vue?vue&type=script&lang=js&"
export * from "./ButelProxyList.vue?vue&type=script&lang=js&"
import style0 from "./ButelProxyList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ButelProxyList.vue?vue&type=style&index=1&id=ffc252a0&scoped=true&lang=css&"
import style2 from "./ButelProxyList.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc252a0",
  null
  
)

export default component.exports